// extracted by mini-css-extract-plugin
export var standaloneTable = "_hb-0";
export var standaloneTableWithBodyFill = "_hb-1";
export var withExtraHeader = "_hb-2";